"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceList = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var SourceList = function SourceList() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M40.02,35.98l8.54,8.54c4.11,4.11,4.11,10.79,0,14.9l0,0c-4.11,4.11-10.79,4.11-14.9,0l-9.87-9.87\r c-4.11-4.11-4.11-10.79,0-14.9l0,0c0.54-0.54,1.12-1,1.73-1.4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M14.68,40.44l-8.54-8.54c-4.11-4.11-4.11-10.79,0-14.9l0,0c4.11-4.11,10.79-4.11,14.9,0l9.87,9.87\r c4.11,4.11,4.11,10.79,0,14.9l0,0c-0.54,0.54-1.12,1-1.73,1.4"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        points: "27.08,13.61 50.82,13.61 50.82,37.36 \t"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        points: "51.56,2.5 61.94,2.5 61.94,12.87 \t"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "61.04",
        y1: "3.4",
        x2: "43.11",
        y2: "21.32"
      })]
    })
  });
};
exports.SourceList = SourceList;